import { Component } from '@angular/core';

@Component({
	selector: 'indra-flight-check-in',
	template: '<div>loading indra template...check modules and routes</div>'
})
export class FlightCheckInComponent {
	constructor() {}
}
